import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import OrderDetail from './components/OrderDetail';
import VendorManager from './components/VendorManager';
import VendorLogin from './components/VendorLogin';
import VendorDashboard from './components/VendorDashboard';
import VendorOrderDetail from './components/VendorOrderDetail';
import ImportOrder from './components/ImportOrder';

const PrivateRoute = ({ children, requireAdmin = false }) => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="loading-screen">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !isAdmin()) return <Navigate to="/dashboard" replace />;
  return children;
};

const VendorPrivateRoute = ({ children }) => {
  const token = localStorage.getItem('ts_token');
  const user = JSON.parse(localStorage.getItem('ts_user') || 'null');
  if (token && user?.role === 'vendor') return children;
  return <Navigate to="/vendor/login" replace />;
};

function App() {
  const { user } = useAuth();
  return (
    <div className="app">
      <Routes>
        {/* Admin routes */}
        <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/orders/:orderId" element={<PrivateRoute><OrderDetail /></PrivateRoute>} />
        <Route path="/vendors" element={<PrivateRoute requireAdmin={true}><VendorManager /></PrivateRoute>} />
        <Route path="/import" element={<PrivateRoute requireAdmin={true}><ImportOrder /></PrivateRoute>} />

        {/* Vendor routes */}
        <Route path="/vendor/login" element={<VendorLogin />} />
        <Route path="/vendor/dashboard" element={<VendorPrivateRoute><VendorDashboard /></VendorPrivateRoute>} />
        <Route path="/vendor/order/:id" element={<VendorPrivateRoute><VendorOrderDetail /></VendorPrivateRoute>} />

        {/* Default */}
        <Route path="/" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
      </Routes>
    </div>
  );
}

export default App;
